import type { SVGProps } from "react";

export default function PlayIcon({
  className,
  ...props
}: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.6582 9.28663C18.098 10.1864 18.8178 10.6363 19.0647 11.2124C19.2803 11.7154 19.2803 12.2849 19.0647 12.788C18.8178 13.364 18.098 13.8139 16.6582 14.7138L9.896 18.9402C8.29805 19.9389 7.49907 20.4383 6.83973 20.3852C6.26501 20.339 5.73818 20.0471 5.3944 19.5842C5 19.0532 5 18.111 5 16.2266V7.77382C5 5.88944 5 4.94726 5.3944 4.41623C5.73818 3.95335 6.26501 3.66136 6.83973 3.61515C7.49907 3.56215 8.29805 4.06151 9.896 5.06023L16.6582 9.28663Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  );
}
